import axios from "axios";
import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import Barcode from "react-barcode";
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'
  function LabReportOpAll(props) {
      const {appt_id} = useParams();
      const [viewlabdata,setViewLabData] = useState([]);
      const [labtestData,setLabTestData] = useState([]);
      const [fetchedResults, setFetchedResults] = useState([]);
      const [isLoading, setIsLoading] = useState(true);
      const [labDataArray, setLabDataArray] = useState([]);
      const [labbillData, setLabBillData] = useState([]);
      const [labData,setlabData] = useState([]);

useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(baseUrl + 'lab-report-all/' + appt_id + '/');
        setLabTestData(response.data);
        const ltestid = (response.data[0].ltest_id);
        const response2 = await axios.get(baseUrl+'lab-test-view/'+ltestid+'/');
        setLabBillData(response2.data);
        setIsLoading(false);
        const response3 = await axios.get(baseUrl+'lab-pay/'+appt_id);
        setlabData(response3.data);

      } catch (error) {
        console.log(error);
        setIsLoading(false);
      }
    };
    fetchData();
  }, [appt_id]);

  useEffect(() => {
    if (labtestData.length > 0) {
      fetchLabData();
    }
  }, [labtestData]);


async function fetchLabData() {
  const fetchedData = [];
  const allFetchedResults = [];

  for (const test of labtestData) {
    const ltestIds = test.ltest_id.split(',').map(item => item.trim());
    const results = test.results.split(',').map(item => item.trim());

    for (const ltestId of ltestIds) {
      try {
        const response = await axios.get(baseUrl + 'lab-test-view/' + ltestId + '/');
        fetchedData.push(response.data);

      } catch (error) {
        console.log(error);
      }
    }
    allFetchedResults.push(...results);
  }
 
   let flattendArray = fetchedData.flat()
  setViewLabData(flattendArray);
  setFetchedResults(allFetchedResults);
}
  if (isLoading) {
    return <div>Loading...</div>;
  }
   if (!labtestData || labtestData.length === 0) {
    return <div>No data available.</div>;
  }

const updatedLabbillData = viewlabdata.map((testsArray, testIndex) =>{
    let results = fetchedResults[testIndex];
    return (
      <tr key={`${testIndex + 1}`}>
<td>
  <div>{testsArray?.test}</div>
  <div style={{ fontSize: "12px", color: "gray", marginTop: "-2px" }}>
    {testsArray?.method}
  </div>
</td>
        <td>{results}</td>
        <td>{testsArray?.units}</td>
        <td>{testsArray?.ranges}</td>
      </tr>
    );
}

);
const handlePrint = () => {
        const printContents = document.getElementById('invoice-print').innerHTML;
        const originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        setTimeout(() => {
            window.location.reload();
        }, 1000);
        document.body.innerHTML = originalContents;
     };


  return (
    <section>
      <div id="invoice-print">
      {labData.map((row, index) =>
          <div>
                            <table
                  border="0"
                  className="text-justify mt-4"
                  width="100%"
                  style={{
                    borderTop: "2px solid black",
                    borderBottom: "2px solid black",
                    borderCollapse: "collapse",
                  }}
                >
                <tbody>
                  <tr>
                    {/* Left side: Patient details with Barcode */}
                       <td
                        style={{
                          width: "60%",
                          padding: "10px",
                          verticalAlign: "top",

                        }}
                      >
                      <table width="100%" border="0" style={{ borderCollapse: "collapse" }}>
                        <tbody>
                          <tr>
                            <td>PID :</td>
                            <td>
                              <Barcode
                                width={2}
                                height={60}
                                fontSize={12}
                                margin={0}
                                value={row.pat.pat_id}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td>Name :</td>
                            <td>{row.pat.patient}</td>
                          </tr>
                          <tr>
                            <td>Age / Gender :</td>
                            <td>{row.pat.age}/{row.pat.gender}</td>
                          </tr>
                          <tr>
                            <td>Mobile :</td>
                            <td>{row.pat.mobile}</td>
                          </tr>
                          <tr>
                            <td>Consultant :</td>
                            <td>Dr. {row.cons.consultant}</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>

                    {/* Right side: Dates */}
                     <td style={{ padding: "10px", textAlign: "left", verticalAlign: "center" }}>
                    <table border="0" width="100%">
                      <tbody>
                        <tr>
                          <td>Sample Date:</td>
                          <td>{labData[0].add_date}</td>
                        </tr>
                        <tr>
                          <td>Report Date:</td>
                          <td>{labtestData[0].sample_date}</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  </tr>
                </tbody>
              </table>
            </div>

          )}
              <div style={{ marginTop: "20px" }}>
                <table
                  border="0"
                  className="text-justify mt-4"
                  width="100%"
                  style={{
                    borderTop: "2px solid black",
                    borderBottom: "2px solid black",
                    borderCollapse: "collapse",
                  }}
                >
                  <thead
                style={{
                    borderTop: "2px solid black",
                    borderBottom: "2px solid black",
                    borderCollapse: "collapse",
                  }}
                    >
                    <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>

                       <th align="left">Test Description</th>
                       <th align="left">Values</th>

                       <th align="left">Unit</th>
                       <th align="left">Ref. Range</th>

                    </tr>
                  </thead>

              <tbody>
               <tr>
        <td colSpan="4" style={{ textAlign: "center", paddingTop: "10px" }}>
          <h3
            style={{
              color: "black",
              textDecoration: "underline",
              margin: 0,
            }}
          >
            {labbillData.length > 0 && labbillData[0].cat.category}
          </h3>
          </td>
          </tr>
          <tr>
          <td colSpan="4" style={{ textAlign: "left", paddingTop: "10px" }}>
          <h3
            style={{
              color: "black",
              textDecoration: "underline",
              margin: 0,
            }}

          >

            {labbillData.length > 0 && labbillData[0].subcat.subcat}

          </h3>
        </td>
      </tr>

               {updatedLabbillData}
            </tbody>
            </table>
            </div>
            <div style={{
                    marginTop: "40px",
                    borderTop: "1px solid #ccc",
                    paddingTop: "10px",
                    textAlign: "center",
                  }}>
                    <p style={{
                      fontWeight: "bold",
                      marginBottom: "10px",
                      fontSize: "16px",
                    }}>
                      *** End of Report ***
                    </p>

                    {/* Signature Image */}
                    <div style={{ textAlign: "right", marginRight: "40px" }}>
                      <img
                        src="/signlab.jpg"
                        style={{
                          height: "80px",
                          marginBottom: "0px",
                          marginRight: "10px",
                        }}
                      />

                    <p style={{
                      textAlign: "right",
                      marginTop: "5px",
                      fontWeight: "bold",
                      fontSize: "15px",
                    }}>
                      Dr.J.Christinal<br></br>Consultant Biochemist
                    </p>

                    </div>


                    {/* Note on left side */}
                    <div style={{
                      textAlign: "left",
                      fontSize: "13px",
                      marginTop: "15px",
                      color: "#555",
                      fontStyle: "italic",
                    }}>
                      <b>Note</b>: This Report has been digitally certified and it doesnt need a hand signature.
                    </div>
                  </div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <button style={{ padding: '5px 20px', borderRadius: '10px', backgroundColor: '#007bff', color: '#fff' }}
          onClick={handlePrint}
          >
           Print
          </button>
        </div>
    </section>
  );
  }
export default LabReportOpAll;

